import React, {useState, useEffect} from "react";
import {instance} from "../../config/axios-cnf";
import SelectField from "../SelectField";


const ParkingArealField = (props) => {

    let [subject, setSubject] = useState([]);
    let [loading, setLoading] = useState(true);
    let [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => apiGetParkingAreal((data) => {
        let array = [];
        data.map(item => {
            array.push({
                label: item.name,
                value: item.id
            });
        })
        setSubject(array);
        setLoading(false)

    }, err => {
        //Toast.warn(translate("loading_error"))
    }), [])

    return (
        <SelectField {...props}
                     disabled={loading || isDisabled}
                     options={subject}
                     isMandatory={!!props.validate}
                     isMulti={props.isMulti}
        />
    )


}

export const apiGetParkingAreal = (callback, error) => {
    instance.get('/api/v1/parking/areal')
            .then(response => callback(response.data))

}

export default ParkingArealField
